// src/services/gridService.js
import { api } from './api';

const gridService = {
  // Get grid for specific project, month, and platform
  getGrid: async (projectId, month, platform = 'instagram') => {
    try {
      const queryParams = new URLSearchParams({ platform }).toString();
      const response = await api.get(`/grids/${projectId}/${month}?${queryParams}`);
      console.log('Grid service response:', response);
      return response; // Return full response, not response.data
    } catch (error) {
      console.error('Grid service error:', error);
      throw error;
    }
  },

  // Update grid configuration
  updateGrid: async (gridId, updates) => {
    try {
      const response = await api.put(`/grids/${gridId}`, updates);
      return response;
    } catch (error) {
      console.error('Grid update error:', error);
      throw error;
    }
  },

  // Copy grid from another month
  copyGrid: async (projectId, targetMonth, sourceMonth, platform = 'instagram') => {
    try {
      const response = await api.post(`/grids/${projectId}/${targetMonth}/copy`, { sourceMonth, platform });
      return response;
    } catch (error) {
      console.error('Grid copy error:', error);
      throw error;
    }
  },

  // Assign task to cell
  assignTask: async (gridId, taskId, row, column) => {
    try {
      const response = await api.post(`/grids/${gridId}/assign-task`, { taskId, row, column });
      return response;
    } catch (error) {
      console.error('Task assignment error:', error);
      throw error;
    }
  },

  // Move task between cells
  moveTask: async (gridId, taskId, fromRow, fromColumn, toRow, toColumn) => {
    try {
      const response = await api.post(`/grids/${gridId}/move-task`, {
        taskId,
        fromRow,
        fromColumn,
        toRow,
        toColumn
      });
      return response;
    } catch (error) {
      console.error('Task move error:', error);
      throw error;
    }
  },

  // Remove task from grid
  removeTask: async (gridId, taskId, row, column) => {
    try {
      // Build query string with row and column if provided
      let url = `/grids/${gridId}/remove-task/${taskId}`;
      if (row !== undefined && column !== undefined) {
        const queryParams = new URLSearchParams({ row: row.toString(), column: column.toString() }).toString();
        url += `?${queryParams}`;
      }
      const response = await api.delete(url);
      return response;
    } catch (error) {
      console.error('Task removal error:', error);
      throw error;
    }
  },

  // Get grids by date range
  getGridsByRange: async (projectId, startDate, endDate) => {
    try {
      // Build query string manually since fetchWithAuth doesn't handle params
      const queryParams = new URLSearchParams({
        startDate: startDate,
        endDate: endDate
      }).toString();
      
      const response = await api.get(`/grids/${projectId}/range?${queryParams}`);
      return response;
    } catch (error) {
      console.error('Grid range fetch error:', error);
      throw error;
    }
  }
};

export default gridService;